import React from 'react';
import {View, Text} from 'react-native';
import {RWebShare} from 'react-web-share';
import {globalFontStyle} from '../../../assets';
import {globalConfigurableData, globalConst} from '../../../utils/globalConstant';
import {
  ic_outline_share_white,
  share_black,
  share_button,
  WhatsApp,
} from '../../../utils/images';
import './shareLinkContest.css';

const ShareLinkContest = ({contestName, prizePool, sharaebleLink}) => {
  return (
    <RWebShare
      data={{
        text:
          'Inviting you to join TradeX group contest - ' +
          contestName +
          ' and win rewards upto 10k. Click below link to join ',

        title: globalConfigurableData?.appName,
        url: 'https://web.tradexapp.co/Home',
      }}>
      <View
        style={{
          borderRadius: 20,
          marginRight: 15,
          borderWidth: 1,
          paddingHorizontal: 15,
          paddingVertical: 5,
        }}>
        <Text style={{...globalFontStyle.appFontBody}}>Invite friend</Text>
      </View>
    </RWebShare>
  );
};
export default ShareLinkContest;
